<template>
    <div id="list-lines-component" class="w-full h-full">
        <div class="flex items-end justify-between gap-2">
            <span v-if="isLoading"> Cargando...</span>
            <custom-simple-select
                v-else
                v-model="option"
                :label="showLabel ? label : ''"
                mode="search"
                class="w-full"
                :options="selectOptions"
                :disabled="!enabled"
                @change="onInput"
            />
            <app-button
                v-if="enabled"
                icon
                circle
                color="brand-purple"
                @click="reloadItems(true)"
            >
                <reload-icon class="h-5 w-5 text-white" />
            </app-button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import ReloadIcon from "@/components/icons/ReloadIcon.vue";
import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "LineSelector",
    components: { ReloadIcon, CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            type: Object,
            default: () => ({
                name: "indefinido",
                slug: ""
            }),
            require: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        },
        fill: {
            default: () => true,
            type: Boolean,
            required: false
        },
        defaultFilters: {
            default: () => ({
                active: true,
                type: "lines"
            }),
            type: Object,
            required: false
        },
        showLabel: {
            default: () => false,
            type: Boolean,
            required: false
        },
        label: {
            default: () => "Categoría",
            type: String,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: "",
        options: [],
        isLoading: true
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"]),
        selectOptions() {
            const options = this.options || [];
            return [
                { label: "Sin categoría principal", value: "" },
                ...options.map((item) => ({
                    label: item.name,
                    value: item.slug
                }))
            ];
        }
    },
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
        this.reloadItems(true);
    },
    methods: {
        ...mapActions("commons", ["listAllLinesQuery"]),
        async reloadItems(required = true) {
            this.isLoading = true;
            try {
                this.options = await this.listAllLinesQuery({
                    required,
                    ...this.defaultFilters
                });
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        setInput(value) {
            if (!value || !value.slug) {
                this.option = "";
                this.isLoading = false;
                return;
            }
            const aux = this.options.find((item) => item.slug === value.slug);
            if (!aux) {
                this.options = [value];
            }
            this.option = value.slug ?? "";
            this.isLoading = false;
        },
        onInput() {
            if (!this.option) {
                this.$emit("change", { name: "", slug: "" });
                return;
            }
            const aux = this.options.find((item) => this.option === item.slug);
            if (aux) {
                this.$emit("change", aux);
            }
        }
    }
};
</script>
